/* src/app/views/dashboard/components/sidebar-nav/sidebar-nav.component.scss */
.bs-light {
  font-family: poppins, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-medium-italic {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: italic;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.nav-list {
  padding-inline-start: unset;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}
.nav-list li:nth-last-child(2) {
  margin-top: auto;
}
.bs-menu-nav {
  padding: 0.5rem;
  margin-top: 8rem;
}
.nav-logo {
  position: absolute;
  margin: 2rem 1rem;
  cursor: pointer;
  width: 5rem;
}
.bs-nav-item {
  display: block;
  cursor: pointer;
}
.nav-item-label {
  display: inline-block;
  width: calc(100% - 4rem);
  font-size: 0.9rem;
}
.nav-item-icon {
  display: inline-block;
}
.sidebar-logo {
  flex-grow: 0;
}
.location-picker {
  display: inline-block;
  float: right;
  opacity: 1;
  height: 100%;
}
.sidebar-software-version {
  position: absolute;
  bottom: 0;
  margin-left: 0.5rem;
  margin-bottom: 0.25rem;
  font-size: 0.75rem;
  color: #222222;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
}
.sidebar-software-version .refresh-container {
  display: flex;
  overflow: visible;
}
.sidebar-software-version .refresh-container .spin-refresh {
  width: 0.5rem;
  height: 0.5rem;
  animation: spin-ccw 1.5s linear infinite;
}
.sidebar-software-version .web_socket_connection_status {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
}
@keyframes spin-ccw {
  100% {
    transform: rotate(-360deg);
  }
}
/*# sourceMappingURL=sidebar-nav.component.css.map */
